<!-- eslint-disable no-bitwise -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="project-file-create col-lg-10 pb-4">
    <div class="project-file-create__head h6 mt-2">
      <ul class="project-file-create__file-path">
        <li class="project-file-create__file-path-item-head">
          <router-link
            class="f4"
            tag="a"
            :to="{
              name: 'project-files',
              query: {
                ...(commit ? { commit: commit } : {}),
                ...(branch && !commit ? { branch: branch } : {})
              }
            }"
            active-class=""
            exact-active-class=""
            exact
          >
            {{ projectAlias }}
          </router-link>
          <span class="project-file-create__path-divider f4">/</span>
        </li>
        <li
          v-for="(fileName, index) in filePath?.split('/')"
          v-if="filePath"
          :key="index"
          class="project-file-create__file-path-item"
        >
          <router-link
            tag="a"
            :to="{
              name: 'project-files',
              query: {
                file: getFilePathByFileName(fileName),
                ...(commit ? { commit: commit } : {}),
                ...(branch && !commit ? { branch: branch } : {})
              }
            }"
            active-class=""
            exact-active-class="active"
            exact
          >
            {{ fileName }}
          </router-link>
          <span class="project-file-create__path-divider f4">/</span>
        </li>
        <li class="project-file-create__file-path-item-head">
          <input
            ref="fileName"
            v-model="fileName"
            type="text"
            :placeholder="$t('file.fileName')"
            class="form-control form-control-sm"
          />
        </li>
      </ul>
      <div class="project-file-create__head-action-buttons">
        <button
          class="btn btn-sm btn-dark"
          type="button"
          @click="onDiscardChangesClick"
        >
          {{ $t('message.cancel_changes') }}
        </button>
        <button
          class="btn btn-sm btn-success"
          type="button"
          :disabled="!canCommit"
          data-target="createFileModal"
        >
          {{ $t('commit.create') }}
        </button>
      </div>
    </div>
    <div
      v-if="!hasError"
      class="project-file-create__body"
    >
      <div class="project-file-create__body-head">
        <div
          v-if="isEditorLoaded"
          class="project-file-create__body-head-content"
        >
          <div class="project-file-create__body-head-actions">
            <select
              v-model="indentMode"
              class="form-control form-control-sm"
              name="indentMode"
              @change="onIndentModeChange"
            >
              <option value="Tabs">Tabs</option>
              <option value="Spaces">Spaces</option>
            </select>
          </div>
          <div class="project-file-create__body-head-actions">
            <select
              v-model="indentSize"
              class="form-control form-control-sm"
              name="indentSize"
              @change="onIndentSizeChange"
            >
              <option :value="2">2</option>
              <option :value="4">4</option>
              <option :value="8">8</option>
            </select>
          </div>
          <div
            class="project-file-create__body-head-actions btn-group btn-group-sm"
            role="group"
          >
            <button
              class="btn btn-outline-secondary text-secondary"
              type="button"
              :title="$t('file.doNotWrapLines')"
              :style="{
                'background-color': !isTextWrap ? 'var(--bg-light-selected)' : 'var(--white)'
              }"
              @click="onNotTextWrapClick"
            >
              <i
                class="gf-icon gf-icon-arrows-left-right"
                :style="{ color: !isTextWrap ? 'var(--text)' : 'var(--text-muted)' }"
              />
            </button>
            <button
              class="btn btn-outline-secondary text-secondary"
              type="button"
              :title="$t('file.wrapLines')"
              :style="{
                'background-color': isTextWrap ? 'var(--bg-light-selected)' : 'var(--white)'
              }"
              @click="onTextWrapClick"
            >
              <i
                class="gf-icon gf-icon-arrow-turn-down"
                :style="{ color: isTextWrap ? 'var(--text)' : 'var(--text-muted)' }"
              />
            </button>
          </div>
        </div>
      </div>
      <div class="project-file-create__body-file">
        <div ref="editorContainer" />
        <packman-loader
          v-if="!isEditorLoaded"
          size="15"
          :style="{ top: '35%' }"
        />
      </div>
    </div>
    <div
      v-else
      class="project-file-create__not-found"
    >
      <h4>404</h4>
      <h6>{{ $t('message.error_occured') }}</h6>
      <router-link
        class="mt-1 btn btn-dark btn-sm"
        tag="button"
        :to="{
          name: 'project-file-blob',
          query: this.$route.query
        }"
        active-class=""
        exact-active-class=""
        exact
      >
        {{ $t('file.returnToFileView') }}
      </router-link>
    </div>
    <gf-custom-modal-window
      ref="gfCustomModalWindowCreateFile"
      gf-modal-data-name="createFileModal"
      :gf-modal-header="$t('commit.create')"
      gf-modal-wrapper-width="500px"
      @close="resetErrors"
    >
      <template #body>
        <project-commit-form
          :branch="branch"
          :lastCommitHash="commit"
          :file-name="fileName"
          :is-new-repo="isNewRepo"
          action-type="create"
          submit-button-text="Создать файл"
          @cancel="closeCreateFileModal"
          @submit="createFile"
        />
      </template>
    </gf-custom-modal-window>
  </div>
</template>

<script>
import RepoS from '@shared/services/repository.service';
import loader from '@monaco-editor/loader';
import { FORM_NAME_ENUMS } from '@shared/variables/form-name.enums';
import qs from 'qs';
import { messageNotification } from '@shared/services/gf.notification.service';
import * as monaco from 'monaco-editor';
import projectFilesMessages from '@/shared-modules/modules/project-files/project-files.messages';
import GfCustomModalWindow from '@/shared-modules/shared-components/shared/GfCustomModalWindow';
// eslint-disable-next-line max-len
import projectCommitForm from '@/shared-modules/modules/project-files/components/project-commit-form';
import packmanLoader from '@/shared-modules/shared-components/shared/packman-loader';
import languages from '@/assets/js/languages';
import gfEditorLightTheme from '@/assets/js/gf-code-editor/gf-editor-light-theme';
import gfEditorDarkTheme from '@/assets/js/gf-code-editor/gf-editor-dark-theme';

export default {
  name: 'ProjectFileCreate',
  components: { GfCustomModalWindow, projectCommitForm, packmanLoader },
  data() {
    return {
      lastCommitBranch: null,
      hasError: false,
      editor: {},
      fileLinesNumber: 0,
      isTextWrap: false,
      fileName: '',
      rawFile: '',
      fileExtension: 'plaintext',
      indentMode: 'Spaces',
      indentSize: 2
    };
  },
  computed: {
    branch() {
      return this.$route?.query?.branch || document.getElementById('currentBranch')?.value;
    },
    commit() {
      return this.$route?.query?.commit;
    },
    alias() {
      return this.$route?.params?.alias;
    },
    projectAlias() {
      return this.$route?.params?.projectAlias;
    },
    filePath() {
      return this.$route?.query?.file;
    },
    files() {
      return this.$store.getters.getNodeChildrenByPath(this.filePath || '');
    },
    editorColorVersion() {
      return this.$store.getters.getColorScheme === 'light' ? 'gf-editor-light' : 'gf-editor-dark';
    },
    monacoInstance() {
      // eslint-disable-next-line no-underscore-dangle
      return loader.__getMonacoInstance();
    },
    fileContent() {
      return Object.keys(this.editor).length > 0 ? this.editor.getModel().getValue() : '';
    },
    canCommit() {
      return (
        Object.keys(this.editor)?.length > 0 &&
        this.fileName?.length > 0 &&
        this.fileContent?.length > 0
      );
    },
    isEditorLoaded() {
      return Object.keys(this.editor)?.length > 0;
    },
    fileLanguage() {
      const fileExtension = `.${this.fileName.split('.').pop()}`;
      let fileLanguage = 'plaintext';
      // eslint-disable-next-line no-restricted-syntax
      for (const languageName in languages) {
        if (languages[languageName]?.extensions?.includes(fileExtension)) {
          fileLanguage = languageName;
          break;
        }
      }
      fileLanguage = fileLanguage.toLocaleLowerCase();
      switch (fileLanguage) {
        case 'vue':
          fileLanguage = 'html';
          break;
        case 'svelte':
          fileLanguage = 'html';
          break;
        case 'gcc machine description':
          fileLanguage = 'markdown';
          break;
        case 'c++':
          fileLanguage = 'cpp';
          break;
        default:
          break;
      }
      return fileLanguage;
    },
    isNewRepo() {
      return !!this.$route.query.isNewRepo;
    }
  },
  watch: {
    editorColorVersion() {
      this.monacoInstance.editor.setTheme(this.editorColorVersion);
    },
    fileLanguage() {
      if (this.isEditorLoaded) {
        const language = this.fileLanguage;
        if (this.fileExtension !== language) {
          this.fileExtension = language;
          this.monacoInstance.editor.setModelLanguage(this.editor.getModel(), this.fileExtension);
        }
      }
    }
  },
  mounted() {
    if (this.$route?.query?.filename) {
      this.fileName = this.$route?.query?.filename;
    }
    this.$refs.fileName.focus();
    if (this.commit) {
      this.lastCommitBranch = { hash: this.commit };
      this.createEditor();
    } else {
      if (this.isNewRepo) {
        this.createEditor();
      } else {
        RepoS.getLastBranchCommit(this.alias, this.projectAlias, { branchName: this.branch }).then(
          (res) => {
            this.lastCommitBranch = res;
            this.createEditor();
          }
        );
      }
    }

    document.addEventListener('keydown', this.onKeydownSave);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydownSave);
  },
  methods: {
    onKeydownSave(e) {
      if ((e.ctrlKey || e.metaKey) && e.key === 's' && this.canCommit) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.openCreateFileModal();
      }
    },
    getFilePathByFileName(fileName) {
      return this.filePath.split(fileName)[0] + fileName;
    },
    createThemes() {
      this.monacoInstance.editor.defineTheme('gf-editor-light', gfEditorLightTheme);
      this.monacoInstance.editor.defineTheme('gf-editor-dark', gfEditorDarkTheme);
    },
    createEditor() {
      loader.config({ monaco });
      loader.init().then((monaco) => {
        this.createThemes();
        this.editor = monaco.editor.create(this.$refs.editorContainer, {
          value: this.rawFile,
          theme: this.editorColorVersion,
          automaticLayout: true,
          formatOnType: true,
          formatOnPaste: true,
          autoClosingQuotes: true,
          minimap: {
            enabled: false
          },
          scrollbar: {
            alwaysConsumeMouseWheel: false,
            vertical: 'hidden',
            verticalScrollbarSize: 0
          },
          autoClosingBrackets: false,
          // matchBrackets: 'always',
          scrollBeyondLastLine: false,
          defaultLanguage: 'javascript',
          contextmenu: false
        });

        this.monacoInstance.editor.addKeybindingRule({
          // eslint-disable-next-line no-bitwise
          keybinding: monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyF,
          command: null
        });

        this.editor.onDidChangeCursorPosition(() => {
          const editorDomElement = this.$refs.editorContainer;
          const cursorPosition = this.editor.getPosition();
          const cursorCoords = this.editor.getScrolledVisiblePosition(cursorPosition);

          const editorTop = editorDomElement.getBoundingClientRect().top;
          const cursorTop = cursorCoords.top + editorTop;

          if (cursorTop > window.innerHeight - 50) {
            window.scrollBy(0, cursorTop - window.innerHeight + 50);
          } else if (cursorTop < 50) {
            window.scrollBy(0, cursorTop - 50);
          }
        });

        this.editor.getModel().onDidChangeContent(() => {
          const editorLinesNumber = this.isTextWrap
            ? this.editor.getModel().getLineCount()
            : this.fileContent.split('\n').length;
          if (editorLinesNumber !== this.fileLinesNumber) {
            this.fileLinesNumber = editorLinesNumber;
            this.updateEditorHeight();
          }
        });

        if (!this.getFileTextWrapCookie()) {
          this.onNotTextWrapClick();
        } else {
          // eslint-disable-next-line no-unused-expressions
          this.getFileTextWrapCookie() === 'true'
            ? this.onTextWrapClick()
            : this.onNotTextWrapClick();
        }

        this.indentMode = this.editor.getModel().getOptions().insertSpaces ? 'Spaces' : 'Tabs';
        this.indentSize = this.editor.getModel().getOptions().indentSize;
        this.updateEditorHeight();
      });
    },
    updateEditorHeight() {
      const contentHeight = `${this.editor.getContentHeight() + 50}px`;
      this.$refs.editorContainer.style.height = contentHeight;
    },
    setFileTextWrapCookie(isTextWrap) {
      document.cookie = `isFileTextWrap=${isTextWrap}; expires=${new Date(
        new Date().getTime() + 1000 * 60 * 60 * 24 * 365
      ).toGMTString()}; path=/`;
    },
    getFileTextWrapCookie() {
      function escape(s) {
        // eslint-disable-next-line no-useless-escape
        return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1');
      }
      const match = document.cookie.match(RegExp(`(?:^|;\\s*)${escape('isFileTextWrap')}=([^;]*)`));
      return match ? match[1] : null;
    },
    onNotTextWrapClick() {
      this.isTextWrap = false;
      this.editor.updateOptions({ wordWrap: 'off' });
      this.updateEditorHeight();
      this.setFileTextWrapCookie(false);
    },
    onTextWrapClick() {
      this.isTextWrap = true;
      this.editor.updateOptions({ wordWrap: 'on' });
      this.updateEditorHeight();
      this.setFileTextWrapCookie(true);
    },
    onIndentModeChange() {
      this.editor.updateOptions({
        insertSpaces: this.indentMode === 'Spaces',
        detectIndentation: false
      });
    },
    onIndentSizeChange() {
      this.editor.updateOptions({
        indentSize: this.indentSize,
        tabSize: this.indentSize,
        detectIndentation: false
      });
    },
    onDiscardChangesClick() {
      this.$router.push({ name: 'project-files', query: { ...this.$route.query } });
    },
    createFile(data) {
      this.$emit('submit');
      const createdFile = new File([this.fileContent], this.fileName, {
        type: 'text/plain'
      });
      const formData = new FormData();
      formData.append('files', createdFile);
      formData.append('commitHash', this.isNewRepo ? '' : this.lastCommitBranch?.hash);
      formData.append('sourceBranch', this.branch);
      formData.append('targetBranch', data.isDirectCommit ? this.branch : data.newBranchName);
      formData.append('commitMessage', data.message);
      formData.append('filesPath', this.filePath || '');
      formData.append('projectAlias', this.projectAlias);
      formData.append('ownerAlias', this.alias);
      RepoS.uploadFiles(this.alias, this.projectAlias, formData)
        .then((newData) => {
          const fullFilePath = newData?.filesPath
            ? `${newData?.filesPath}/${this.fileName}`
            : this.fileName;
          const encodedParams = qs
            .stringify({
              file: fullFilePath,
              branch: newData.targetBranch
            })
            .replace(/%25/g, '%');
          window.location.href = `/project/${this.alias}/${this.projectAlias}/blob?${encodedParams}`;
        })
        .catch((err) => {
          if (err?.response?.data?.status === 403) {
            this.closeCreateFileModal();
            messageNotification('danger', {
              message: err.response.data.detail,
              hasTimer: false
            });
          }
        });
    },
    closeCreateFileModal() {
      this.$refs.gfCustomModalWindowCreateFile.closeModalWindow();
      this.resetErrors();
    },
    openCreateFileModal() {
      this.$refs.gfCustomModalWindowCreateFile.openModalWindow();
    },
    resetErrors() {
      this.$store.dispatch('setFormErrors', {
        formName: FORM_NAME_ENUMS.UPLOAD_FILES_FORM,
        errorResponse: null
      });
    }
  },
  i18n: { messages: projectFilesMessages }
};
</script>

<style lang="scss">
$this: '.project-file-create';

#{$this} {
  @media screen and (max-width: 767px) {
    height: calc(100% - 30px);
  }

  #{$this}__head {
    min-height: 29px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    @media screen and (max-width: 543px) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }

    &-copy-path {
      width: 30px;
      display: inline-block;
    }

    &-action-buttons {
      display: flex;
      gap: 8px;
    }
  }
  #{$this}__file-path {
    padding: 0;
    margin: 0 5px 0 0;
    list-style: none;

    &-item-head {
      display: inline-block;
      font-weight: 550;
      letter-spacing: 0.015rem;
    }
    &-item {
      display: inline-block;
      font-weight: normal;
    }
  }
  #{$this}__path-divider {
    margin-right: 3px;
    color: var(--text-muted);
    font-weight: normal;
  }
  #{$this}__body {
    &-head {
      min-height: 42px;
      padding: 4px 12px;
      color: var(--text-muted);
      background-color: var(--light);
      border: 1px solid var(--border-color);
      border-top-left-radius: var(--border-radius);
      border-top-right-radius: var(--border-radius);

      &-content {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;
      }

      &-actions * {
        padding: 0.1rem 0.3rem;
      }
    }

    &-file {
      min-height: 40px;
      position: relative;
      padding-bottom: 16px;
      border: 1px solid var(--border-color);
      border-top: none;
      border-bottom-left-radius: var(--border-radius);
      border-bottom-right-radius: var(--border-radius);

      & > div {
        padding-top: 12px;
      }
    }
  }

  #{$this}__not-found {
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    align-items: center;
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
  }
}
</style>
